import styled from "styled-components";

// import colors from '../../constants/colors'
import breakpoints from "../../constants/breakpoints";
import fonts from "../../constants/fonts";

export const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100v%;
  overflow-y: auto;
  scroll-behavior: smooth;
  & > span {
    position: fixed;
    bottom: 32px;
    right: 32px;
    z-index: 100;
    cursor: pointer;
    @media screen and (max-width: ${breakpoints.desktopXL.pixels}) {
      & > svg {
        transform: scale(0.6);
      }
    }
    @media screen and (max-width: ${breakpoints.ipad.pixels}) {
      bottom: 8px;
      right: 8px;
      & > svg {
        transform: scale(0.4);
      }
    }
  }
`;

export const Hero = styled.div`
  background-image: url(${require("./cover.jpg")});
  background-position: center;
  background-repeat: no-repeat;
  object-fit: cover;
  background-size: cover;
  width: 100vw;
  height: 100vh;

  & > div:last-of-type {
    display: flex;
    flex-direction: column;
    padding: 8% 8%;
    height: 100vh;
    justify-content: center;
    @media screen and (max-width: 800px) {
      align-items: center;
      & > svg {
        transform: scale(0.7);
      }
    }
    @media screen and (max-width: 600px) {
      height: auto;
      padding: 0 8% 8% 8%;
      & > svg {
        transform: scale(0.5);
      }
    }

    & > div {
      display: flex;
      flex-direction: row;
      @media screen and (max-width: 800px) {
        flex-direction: column;
      }
      & > button {
        width: 243px;
        height: 39px;
        font-size: 18px;
        border: none;
        border-radius: 25px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        cursor: pointer;
        background-color: #e8c468;
        margin: 32px 0 0 5%;
        @media screen and (max-width: 800px) {
          margin: 16px 0;
        }
        &:hover {
          background-color: rgba(232, 196, 104, 0.8);
        }
      }
    }
  }
`;

export const FirstSection = styled.section`
  display: flex;
  flex-direction: row;
  @media screen and (max-width: 850px) {
    flex-direction: column;
  }

  & > div:first-of-type {
    width: 60%;
    display: flex;
    flex-direction: column;
    padding: 4% 0 4% 8%;
    justify-content: center;
    @media screen and (max-width: 850px) {
      width: 100%;
    }
    @media screen and (max-width: 600px) {
      padding: 16px;
      align-items: center;
      & > svg {
        transform: scale(0.6);
      }
    }

    & > p {
      margin: 70px 0 0 0;
      width: 80%;
      font-size: 20px;
      line-height: 34px;
      font-family: ${fonts.primary}, Helvetica, sans-serif;
      @media screen and (max-width: ${breakpoints.desktop.pixels}) {
        margin: 16px 0 0 0;
        line-height: 24px;
      }
      @media screen and (max-width: 850px) {
        width: 100%;
      }
      @media screen and (max-width: 600px) {
        font-size: 16px;
      }
      & > span {
        font-weight: 400;
        font-size: 20px;
        line-height: 34px;
        @media screen and (max-width: 600px) {
          font-size: 16px;
          line-height: 24px;
        }
      }
    }
  }
  & > div:last-of-type {
    width: 40%;
    display: flex;
    flex-direction: column;
    background-image: url(${require("./firstImage.jpg")});
    background-position: center;
    background-repeat: no-repeat;
    object-fit: cover;
    background-size: cover;
    @media screen and (max-width: 850px) {
      height: 670px;
      width: 100%;
    }
    @media screen and (max-width: 500px) {
      display: none;
    }
  }
`;
export const SecondSection = styled.section`
  display: flex;
  flex-direction: row;
  margin: 0 0 32px 0;
  background-color: #f9f9f9;
  @media screen and (max-width: 850px) {
    flex-direction: column;
  }

  & > div:first-of-type {
    width: 40%;
    display: flex;
    flex-direction: column;
    background-image: url(${require("./secondImage.jpg")});
    background-position: center;
    background-repeat: no-repeat;
    object-fit: cover;
    background-size: cover;
    @media screen and (max-width: 850px) {
      height: 670px;
      width: 100%;
    }
  }
  & > div:last-of-type {
    height: 100%;
    width: 60%;
    display: flex;
    flex-direction: column;
    padding: 4% 8% 4% 8%;
    justify-content: center;
    @media screen and (max-width: 850px) {
      width: 100%;
    }
    @media screen and (max-width: 600px) {
      padding: 16px;
      align-items: center;
      height: auto;
      & > svg {
        transform: scale(0.6);
      }
    }
    & > p {
      margin: 70px 0 0 0;
      font-size: 20px;
      line-height: 34px;
      font-family: ${fonts.primary}, Helvetica, sans-serif;
      @media screen and (max-width: ${breakpoints.desktop.pixels}) {
        margin: 16px 0 0 0;
        line-height: 24px;
      }
      @media screen and (max-width: 850px) {
        width: 100%;
      }
      @media screen and (max-width: 600px) {
        font-size: 16px;
      }
      & > label {
        font-size: 20px;
        line-height: 34px;
        font-family: ${fonts.primary}, Helvetica, sans-serif;
        font-weight: 600;
        @media screen and (max-width: 600px) {
          font-size: 16px;
          line-height: 24px;
        }
      }

      & > span:first-of-type{
        @media screen and (min-width: 1025px) {
          display: none;
        }
      }

      & > span:nth-of-type(3){
        @media screen and (min-width: 1025px) {
          display: none;
        }
      }

      & > span {
        height: 37px;
        position: relative;
        top: 8px;
        background-color: #f9f9f9;
        @media screen and (max-width: 1024px) {
          font-size: 16px;
          height: 24px;
          top: 0;
          & > svg {
            display: none;
          }
        }
      }
    }
  }
`;

export const Block = styled.section`
  display: flex;
  flex-direction: row;
  margin: 32px 0;
  position: relative;
  @media screen and (max-width: 600px) {
    flex-direction: column;
    & > svg {
      display: none;
    }
  }
  & > svg {
    top: 80%;
    position: absolute;
    z-index: 5;
  }
  & > div {
    width: 50%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0 8%;
    @media screen and (max-width: 600px) {
      width: 100%;
      & > svg {
        display: none;
      }
    }
    & > div {
      & h3 {
        color: #e86f51;
        margin: 0;
        font-size: 35px;
        font-weight: 400;
        line-height: 36px;
      }
      & h4 {
        color: #f5a462;
        font-size: 33px;
        font-weight: 600;
        font-family: ${fonts.secondary}, Helvetica, sans-serif;
        line-height: 37px;
        margin: 0;
        @media screen and (max-width: 600px) {
          font-size: 20px;
        }
      }
      & p {
        font-size: 20px;
        font-weight: 400;
        line-height: 37px;
        color: #5798c0;
        font-family: ${fonts.primary}, Helvetica, sans-serif;
        @media screen and (max-width: 600px) {
          font-size: 16px;
          line-height: 24px;
        }
      }
      & button {
        width: 243px;
        height: 39px;
        font-size: 18px;
        border: none;
        cursor: pointer;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        color: white;
        background-color: #e8c468;
        border-radius: 25px;
        &:hover {
          background-color: rgba(232, 196, 104, 0.8);
        }
      }
    }
  }
`;

export const Materiali = styled.section`
  display: flex;
  flex-direction: column;
  padding: 4% 8%;
  background-color: #e86f51;
  color: white;
  margin: 32px 0 0 0;
  position: relative;
  z-index: 10;

  & > svg {
    position: absolute;
    top: -50px;
    right: 10%;
  }

  & > h2 {
    font-size: 35px;
    line-height: 36px;
    font-weight: 400;
  }
  & > div {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    padding: 2% 0;
    @media screen and (max-width: 600px) {
      flex-direction: column;
    }
  }
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  background-color: #e86f51;
  @media screen and (max-width: 820px) {
    & > svg {
      transform: scale(0.7);
    }
  }

  & > span:first-of-type {
    margin: 32px 0;
    font-size: 70px;
    line-height: 36px;
    @media screen and (max-width: 820px) {
      font-size: 40px;
      line-height: 36px;
    }
    @media screen and (max-width: 600px) {
      margin: 8px 0;
    }
  }
  & > span {
    font-size: 23px;
    line-height: 26px;
    @media screen and (max-width: 820px) {
      font-size: 16px;
      line-height: 20px;
    }
    @media screen and (max-width: 600px) {
      margin: 8px 0;
    }
  }
`;

export const Istituto = styled.section`
  display: flex;
  flex-direction: row;
  background-color: #5bb5d9;
  color: white;
  z-index: 10;
  @media screen and (max-width: 850px) {
    flex-direction: column;min-height: 670px;
    height: auto;
  }
  & > div:first-of-type {
    height: 100%;
    width: 60%;
    display: flex;
    flex-direction: column;
    padding: 4% 8% 4% 8%;
    justify-content: center;
    align-items: center;
    @media screen and (max-width: 850px) {
      width: 100%;
    }
    & > h2 {
      font-size: 35px;
      line-height: 36px;
      font-weight: 400;
      width: 100%;
      margin-top: 0;
      @media screen and (max-width: 600px) {
        margin: 8px 0 0 0;
      }
    }
    & > p {
      margin: 32px 0 0 0;
      width: 100%;
      font-size: 20px;
      line-height: 37px;
      font-family: ${fonts.primary}, Helvetica, sans-serif;
      @media screen and (max-width: ${breakpoints.desktopXL.pixels}) {
        margin: 16px 0 0 0;
        line-height: 24px;
      }
      @media screen and (max-width: 850px) {
        width: 100%;
      }
      @media screen and (max-width: 600px) {
        font-size: 16px;
        margin: 8px 0 0 0;
      }
      & > a {
        outline: none;
        color: white;
      }
      & > span {
        font-weight: 600;
        font-size: 20px;
        line-height: 37px;
        @media screen and (max-width: 600px) {
          font-size: 16px;
        }
      }
    }
  }
  & > div:last-of-type {
    width: 40%;
    display: flex;
    flex-direction: column;
    background-image: url(${require("./thirdImage.jpg")});
    background-position: center;
    background-repeat: no-repeat;
    object-fit: cover;
    background-size: cover;
    @media screen and (max-width: 850px) {
      width: 100%;
      min-height: 670px;
    }
  }
`;

export const ScrollContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  & > div {
    position: absolute;
    right: 50%;
    left: 50%;
    top: 5%;
    @media screen and (max-width: ${breakpoints.desktop.pixels}) {
      & > svg {
        display: none;
      }
    }
  }
`;

export const PallinoWrap = styled.div`
  position: sticky;
  min-width: 60px;
  height: 0;
  top: 0;
  z-index: 1;
  @media screen and (max-width: ${breakpoints.desktop.pixels}) {
    display: none;
  }
  & > svg {
    position: absolute;
    top: 45px;
    left: calc(50% - 16px);
  }
`;

export const Shadow = styled.section`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 5;

  & > div {
    position: relative;
    height: 60vh;
    width: 70vw;
    margin: auto;
    background-color: white;
    border-radius: 20px;
    padding: 64px;
    height: 100%;
    overflow-y: scroll;
    & > article {
      & > label {
        font-weight: 600;
      }
      & > span {
        font-style: italic;
      }
    }
    @media screen and (max-width: ${breakpoints.desktopXL.pixels}) {
      width: 90vw;
      height: 90vh;
    }
    @media screen and (max-width: ${breakpoints.desktop.pixels}) {
      width: 100vw;
      height: 100vh;
      border-radius: 0;
      padding: 64px 16px;
    }

    & > span {
      position: absolute;
      top: 24px;
      right: 32px;
      font-weight: 600;
      cursor: pointer;
    }
  }
`;
